import { FormHelperText } from "@material-ui/core";

export type { FormHelperTextProps } from "@material-ui/core";

export default FormHelperText;
